import React, { FunctionComponent } from "react"
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useBatchPageContext } from "../useBatchPageContext"
import { Fields, updateSelect } from "../reducer"
import styles from "./RecordingAffectOptions.module.scss"

export const RecordingAffectOptions: FunctionComponent = props => {
    const { state, dispatch } = useBatchPageContext()
    const { fields } = state

    const sourceLanguageName = state.allLanguages[state.sourceLanguage]?.name ?? "Source"
    const targetLanguageName = state.allLanguages[state.targetLanguage]?.name ?? "Target"

    return (
        <Grid
            container
            spacing={2}
            direction="column"
            alignContent="flex-start"
            data-testid="recording-affect-options"
        >
            <Grid item>
                <Typography variant="body1">Recording Affect Options</Typography>
            </Grid>
            <Grid
                container
                direction="row"
                spacing={1}
                alignContent="flex-start"
                className={styles.OptionsContainer}
            >
                <Grid item>
                    <FormControl
                        variant="outlined"
                        id="select-source-language-voice-control"
                        data-testid="source-language-voice-select"
                    >
                        <InputLabel
                            id="select-source-language-voice-label"
                            htmlFor={"source-voice"}
                            className={styles.SelectLabel}
                        >
                            {`${sourceLanguageName} Voice`}
                        </InputLabel>
                        <Select
                            className={styles.Select}
                            id="source-voice"
                            labelId="select-source-language-voice-label"
                            inputProps={{ "data-testid": "select-source-voice" }}
                            value={fields.sourceVoice.value}
                            onChange={(e: any) => {
                                dispatch(updateSelect(Fields.SourceVoice, e.target.value))
                            }}
                        >
                            {state.voiceOptions.source.map(voice => {
                                return (
                                    <MenuItem key={voice.id} value={voice.id}>
                                        {voice.name}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl
                        className={styles.Select}
                        variant="outlined"
                        id="select-target-language-voice-control"
                        data-testid="target-language-voice-select"
                    >
                        <InputLabel
                            id="select-target-language-voice-label"
                            htmlFor={"target-voice"}
                            className={styles.SelectLabel}
                        >
                            {`${targetLanguageName} Voice`}
                        </InputLabel>
                        <Select
                            id="target-voice"
                            labelId="select-target-language-voice-label"
                            inputProps={{ "data-testid": "select-target-voice" }}
                            value={fields.targetVoice.value}
                            onChange={(e: any) => {
                                dispatch(updateSelect(Fields.TargetVoice, e.target.value))
                            }}
                        >
                            {state.voiceOptions.target.map(voice => {
                                return (
                                    <MenuItem key={voice.id} value={voice.id}>
                                        {voice.name}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    )
}
